// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AuthLayout_wrapper__1Orzb","container":"AuthLayout_container__7hjFk","logoWrapper":"AuthLayout_logoWrapper__1_EGO","logo":"AuthLayout_logo__1MD7P"};